import React, { Component } from "react";
import PropTypes from "prop-types";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { Alert } from "modules/theme";
import APIManager from "modules/common/apiManager";
import { Spinner } from "modules/theme";

export class DynamicReport extends Component {
	constructor(props) {
		super(props);
        this.loadingCellRenderer = this.loadingCellRenderer.bind(this);
		this.mAPI = new APIManager();
		this.state = {
			fullScreen: this.props.fullScreen,
			columnList: [],
			rowData: [],
            loading: false,
		};
	}

	getList() {
        this.setState({ loading: true });
		this.mAPI.sendPostAPI(
			this.props.getDataAPI,
			this.props.reportFilter,
			(data) => {
				this.setState({ loading: false });
				if (data) {
                    this.setState({ loading: false });
					if (
						data &&
						data.columes &&
						Array.isArray(data.columes) &&
						data.columes.length
					) {
						const columnList = data.columes.map((column) => ({
							field: column.varibleName,
							headerName: column.label,
							id: column.indexNo,
						}));
						const rowData = data.data.map((row, id) => ({ ...row, id }));
						this.setState({ columnList, rowData: rowData || [] });
					} else {
						this.setState({ columnList: [], rowData: [] });
					}
				} else {
					this.setState({ columnList: [], rowData: [], loading: false });
				}
			},
			(error, data) => {
                this.setState({ loading: false });
				Alert.error(`${error}`);
			}
		);
	}

	startInterval() {
		const autoRefreshTimer = parseInt(this.props.autoRefreshTimer);
		try {
			global[this.props.refreshTimerIdentifier] = setInterval(() => {
				this.getList();
			}, autoRefreshTimer * 1000 || 1500);
		} catch (err) {
			Alert.error(`${err}`);
		}
	}
	stopInterval() {
		try {
			clearInterval(global[this.props.refreshTimerIdentifier]);
		} catch (err) {
			Alert.error(`${err}`);
		}
	}

	componentDidMount() {
		if (this.props.isActive) {
			this.getList();
			if (this.props.autoRefreshTimer !== 0) {
				this.startInterval();
			}
		}
	}

	componentDidUpdate(prevProps) {
		// Perform actions that should happen after the state.timer has been updated
		if (this.props.shouldCallAPI && this.props.isActive) {
			this.getList();
			this.props.setToFalseShouldCallAPI();
		}
		if (this.props.isActive) {
			if (prevProps.autoRefreshTimer !== this.props.autoRefreshTimer) {
				this.stopInterval();
				if (this.props.autoRefreshTimer !== 0) {
					this.startInterval();
				}
			} else {
				if (!prevProps.isActive) {
					this.getList();
					if (this.props.autoRefreshTimer !== 0) {
						this.startInterval();
					}
				}
			}
		} else {
			this.stopInterval();
		}
	}

	componentWillUnmount() {
		this.stopInterval();
	}

	getColumn(columns) {
		let columnDefs = [];
		if (columns && columns.length) {
			columns.map((column) => {
				column.minWidth = column.minWidth || 150;
				column.flex = column.flex || 1;
				column.filter = column.filter || true;
				column.maxWidth = column.maxWidth || 300;
				columnDefs.push(column);
			});
		}
		return columnDefs;
	}

	getRowId(params) {
		return params.data.id;
	}

    loadingCellRenderer() {
        return (
            <Spinner
                  style={{
                    height: '2px',
                    width: '2px',
                    marginTop: '-15px',
                    padding: '10px',
                    marginBottom: '10px',
                  }}
            />
        );
    }

	render() {
		const {
			agStyle = { width: "100%", height: "100%;" },
			divStyle = { height: 400, margin: "0px 0px 10px 0px" },
			agClassName = "ag-theme-alpine",
			boxClassName = "ag-theme-alpine",
		} = this.props;

		let columnDefs = this.getColumn(this.state.columnList);
		let defaultColDef = {
			resizable: true,
			floatingFilter: true,
			sortable: true,
		};

		return (
            this.state.loading ? (
                <Spinner />
            ) : (
			    <div className={boxClassName} style={divStyle}>
			    	<AgGridReact
			    		style={agStyle}
			    		className={agClassName}
			    		onGridReady={(params) => {}}
			    		animateRows={true}
			    		defaultColDef={defaultColDef}
			    		enableRangeSelection="true"
			    		rowData={this.state.rowData || []}
			    		getRowId={this.getRowId}
			    		rowSelection="multiple"
			    		suppressRowClickSelection="true"
			    		columnDefs={columnDefs}
                        loadingCellRenderer={this.loadingCellRenderer}
			    	/>
			    </div>
            )
		);
	}
}
DynamicReport.contextTypes = {
	__: PropTypes.func,
};

export default DynamicReport;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/DynamicReports.jsx